export default {
  namespaced: true,
  actions: {
    create({ commit }, workRight) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.post('admin/work_rights', { workRight })
    },
    destroy({ commit }, id) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.delete(`admin/work_rights/${id}`)
    }
  }
}
